export type AvatarItem = {
  id: number;
  label: string;
  onPress?: () => void;
};

export type MenuItems = {
  id: string;
  label: string;
  icon: string;
  visible: boolean;
  height?: number;
  width?: number;
  url: string;
  urlNative?: string;
};
/** Stable ids for header avatar menu; keep in sync with `AVATAR_ITEMS`. */
export const AVATAR_ACTION_ID = {
  MY_PROFILE: 1,
  SWITCH_PROFILE: 2,
  SWITCH_PRODUCT: 3,
} as const;

export type AvatarActionId =
  (typeof AVATAR_ACTION_ID)[keyof typeof AVATAR_ACTION_ID];

export const AVATAR_ITEMS: AvatarItem[] = [
  { id: 1, label: "My Profile" },
  { id: 2, label: "Switch Profile" },
  { id: 3, label: "Switch Product" },
];

export enum VerticalIDMapping {
  IL = 1,
  SCA = 2,
  META = 3,
  SCHOOL = 4,
  NON_IL_SCA = 5,
}

export const MENU_ITEMS: MenuItems[] = [
  {
    id: "home",
    label: "Home",
    icon: "HomeIcon",
    visible: true,
    height: 20,
    width: 20,
    url: "/dashboard",
    urlNative: "home",
  },
  {
    id: "live-classes",
    label: "Live Classes",
    icon: "live_Classes",
    visible: true,
    height: 20,
    width: 20,
    url: "/live-classes",
    urlNative: "play",
  },
  {
    id: "learn",
    label: "Learn",
    icon: "learn",
    visible: true,
    height: 25,
    width: 22,
    url: "/self-learn",
    urlNative: "self-learn",
  },
  {
    id: "tests",
    label: "Tests",
    icon: "tests",
    visible: true,
    height: 18,
    width: 20,
    url: "/tests",
    urlNative: "explore",
  },
  {
    id: "Doubts",
    label: "Doubts",
    icon: "Doubts",
    visible: true,
    height: 21,
    width: 20,
    url: "/doubts",
    urlNative: "doubts",
  },
  {
    id: "bookmarks",
    label: "My Bookmarks",
    icon: "bookmarks",
    visible: true,
    height: 26,
    width: 25,
    url: "/self-learn/my-bookmarks",
    urlNative: "bookmarks",
  },
  {
    id: "Subscriptions",
    label: "Subscriptions",
    icon: "Subscriptions",
    visible: true,
    height: 21,
    width: 22,
    url: "/subscriptions",
    urlNative: "subscriptions",
  },
  {
    id: "ReferEarn",
    label: "Refer and Earn",
    icon: "ReferEarn",
    visible: true,
    height: 20,
    width: 23,
    url: "/refer-and-earn",
    urlNative: "refer-and-earn",
  },
  {
    id: "contact_us",
    label: "Contact Us",
    icon: "contact_us",
    visible: true,
    height: 12,
    width: 25,
    url: "/contact-us",
    urlNative: "contact-us",
  },
  {
    id: "log_out",
    label: "Log Out",
    icon: "log_out",
    visible: true,
    height: 19,
    width: 19,
    url: "/log-out",
    urlNative: "log-out",
  },
];

/** Hosted intro clip; hosts must use no native controls and no loop. */
export const AINA_INTRO_VIDEO_URL =
  "https://storage.googleapis.com/aina-assets/aina.mp4";

/** `localStorage` (web) / `StorageKeys` (mobile): once set, intro modal is not shown again. */
export const AINA_INTRO_STORAGE_KEY = "aina_intro_dismissed_v1";

/** MMKV (mobile): native app version synced from Gradle / Xcode on home tab. */
export const APP_VERSION_STORAGE_KEY = "app_version";
